<template>
  <div class="quill-wrapper">
    <div ref="editor"></div>
  </div>
</template>

<script>
import Quill from 'quill'
import { assign } from 'lodash'

const defaultOptions = {
  theme: 'snow',
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', { list: 'ordered' }, { list: 'bullet' }]
    ]
  }
}

export default {
  name: 'quill-wrapper',

  props: {
    /**
     * Quill Config
     * Shape:
     * {
     *  value:
     *  options: {}
     * }
     */
    config: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        options: {}
      })
    }
  },

  data: () => ({
    content: null
  }),

  mounted () {
    this.init()
  },

  watch: {
    'config.value' (newVal, oldVal) {
      if (this._quill) {
        if (newVal && newVal !== this.content) {
          this.content = newVal
          this.pasteHtml(newVal)
        } else if (!newVal) {
          this._quill.setText('')
        }
      }
    }
  },

  /**
   * Make sure quill remove from the DOM
   */
  beforeDestroy () {
    this._quill = null
    delete this._quill
  },

  methods: {
    init () {
      this._quill = new Quill(this.$refs.editor, assign({}, defaultOptions, this.config.options))

      const content = this.config.value || this.content
      if (content) {
        this.pasteHtml(content)
        // move cursor to the end
        // this._quill.setSelection(this._quill.getLength() + 1, 0)
      }

      this._quill.on('text-change', () => {
        let rawHtml = this.$refs.editor.children[0].innerHTML

        if (rawHtml === '<p><br></p>' || rawHtml === '<br>') {
          rawHtml = ''
        }

        this.content = rawHtml

        this.$emit('input', this.content)
        this.$emit('change', rawHtml)
      })
    },

    pasteHtml (html) {
      this._quill.setContents(this._quill.clipboard.convert(html))
    }
  }
}
</script>
